import { useNavigate } from "react-router-dom";
import { VenetianMask } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ImpersonationBanner() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  if (!user?.impersonated_by) return null;

  const stop = async () => {
    try {
      const { data } = await api.post("/auth/impersonate/stop");
      setUser(data.user);
      toast.success("Back to your admin account");
      navigate("/admin");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid="impersonation-banner" className="fixed bottom-0 inset-x-0 z-[100] bg-amber-400 text-black px-3 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-sm font-medium shadow-[0_-4px_20px_rgba(0,0,0,0.4)]">
      <VenetianMask size={16} className="shrink-0" />
      <span className="text-center">
        Viewing as <b>{user.name}</b> <span className="hidden sm:inline">({user.email})</span> — admin troubleshooting mode
      </span>
      <button onClick={stop} data-testid="stop-impersonation-btn" className="bg-black text-white rounded-full px-4 py-1.5 text-xs font-bold hover:bg-zinc-800 transition-colors">
        Return to Admin
      </button>
    </div>
  );
}
